import {Schema} from "prosemirror-model";
import nodes from "./Nodes.ts";
import marks from "./Marks.ts";


export function buildSchema():Schema {
	return new Schema({ nodes, marks });
}